<template>
	<Modal v-model="modalVisible" :width="1200" scrollable class-name="vertical-center-modal"   @on-visible-change="onVisibleChange">
		<p slot="header">
			<span>批量编辑产品基础信息</span>		
		</p>
		<Loading :isLoading="saveLoading" />
		<Tabs  :animated="false" :capture-focus="true"  v-model="editType">
			<TabPane label="产品列表" name="productInfo">          
				<productPopupEditTabBathProductList  ref="productList"  @chang-template-product="setProductUuid"
					 />
			</TabPane>
			<TabPane   label="选择要修改的属性"  name="productInfo2">		
				<productPopupEditTabBathInfoList @set-props-event="setPropsList" ref="propBathTab" />
			</TabPane>
			<TabPane   label="基础信息"   v-if="hasTemplateProduct"  name="productInfo3">
				<ProductPopupEdit  :showPropList="showPropList"   ref="productPopupEdit" :dataPath="getUploadData()"  :popupEditResource="popupEditResource"  @on-popup-submit-finish="popupSubmitFinish"/>
			</TabPane>
			<!-- <TabPane    label="基础信息"  name="productInfo3">
				<ProductPopupEdit />
			</TabPane> -->
		</Tabs>
		<div slot="footer">		
			<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
			@click="saveListProductDescriptiveInformation">保存基础信息</Button>
		</div>
	</Modal>
</template>

<script>

import Loading from '@/components/loading/Loading.vue';
import ProductPopupEdit from './product-popup-edit-new-info';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';
import {
    getProductDescriptiveInformation,
    saveProductListDescriptiveInformation
} from '@/api/modules/product-management/productApprove-management';
import { UPLOAD_FILE_API_PATH, FILE_SERVER } from '@/api/modules/files';


import ModalVisible from '@/view/mixins/modal-visible';
import quillUpload from '@/components/quill-upload/quill-upload.vue';
import pdfUpload from './product-popup-edit-pdfUpload.vue';

import productPopupEditTabBathProductList from './product-popup-edit-Tab-Bath-ProductList';
import productPopupEditTabBathInfoList from './product-popup-edit-Base-Bath-infoList';


export default {
    name: 'ProductPopupEditBaseBath',
    components: {
        ProductPopupEdit,
	
        Loading,
	
        productPopupEditTabBathProductList,
        productPopupEditTabBathInfoList
    },
    mixins: [ModalVisible],
    props: {
        productUuidsBathEdit: {
            type: Array,
            default: function () {
                return [];
            }
        },
        popupEditResource: {
            type: Object,
            default() {
                return {
                    seedFarmCode: '',
                    mainCategorySource: [],
                    rawSubCategorySource: [],
                    brandSource: [],
                    serialSource: [],
                    unitSource: [],
                    packageSource: [],
                    masterSource: [],
                    allRegionInfo: [],
                    approvalSource: [],
                    packingFee: '',
                    deliveryFee: '',
                    // productCategoryFeature: '',
                    productDesInfoCultivation: 0,
                    demonstrationVideo2: 0,
                    demonstrationVideo3: 0,
                    demonstrationVideo4: 0,
                    demonstrationVideo5: 0,
                    productDesInfodiscountPolicy: 0,
                    productPreSaleDiscountRatio: 0,
                    productFeatureContract: '',
                    pottingSeedling: 0,
                    seedlingHeight: '',
                    leavesNumber: ''
                };
            }
        }
    },
    data() {
        return {
            qillHeight:440,
            popupEditModalShow: false,
            productUuid:'',
            editType: 'productInfo',			
            uploadImgUrlWithPath:UPLOAD_FILE_API_PATH,
            FILE_SERVER,
            showPropList:[],
            //formEditMode: this.productUuid ?FORM_EDIT_MODE_MODIFY:FORM_EDIT_MODE_CREATE,				
            productForm: {
                productDesInfopOtherSpec: '',
                productDesInffeatures: '',
                productDesInfoCultivation: '',
                productDesInfoCommonProblem: '',
                productDesInfoafterService: '',
                productDesInfodiscountPolicy: '',
                productDesInfoPdfLinkList: '',
                productDesInfoDiseasePestControl: '',
                roductDesInfoPostHarvestProcessing: ''
            },
            saveLoading:false
        };
    },
    watch: {
        productUuid: function (newValue, oldVaule) {			
            // if (newValue) {
            // 	this.getProductDescriptiveInformation(this.productUuid);
            // }
            // else {
            // 	this.clearProductDescriptiveInformation();
            // }
            if(this.productUuid){
                this.$nextTick(()=>{
                    this.$refs.productPopupEdit.onVisibleChange(this.productUuid);
                });				
		
            }
	
        }
    },
    methods: {
        setPropsList(props){			
            this.showPropList=props;
        },
        getUploadData(){
            let uploadData={};
            if(this.productUuid){
                uploadData.updatePath=`ProductImage/`+this.productUuid;
            }
            else{
                uploadData.updatePath=`ProductImage`;
            }
            return uploadData;       
        },
        popupSubmitFinish(){
            // this.$emit('on-popup-submit-finish',formEditMode,productUuid,productCode);
            this.$parent.getMainTableRecords();
            this.$refs.productPopupEdit.onVisibleChange(this.productUuid);
        },
        setProductUuid(productUuid){
            this.productUuid=productUuid;
		
        },
        onVisibleChange(view) {
            if (view) {
                this.editType='productInfo';
                //     let productUuids=['be561798-38f9-45c9-af3e-0ecd5cca482e'];
		         this.$refs.propBathTab.init();
				 this.$refs.productList.init(this.productUuidsBathEdit);
                // if (this.productUuid) {
                // 	this.$nextTick(() => {
                // 		this.$refs.productPopupEdit.onVisibleChange(this.productUuid);
                // 	})
                // }
                // this.getProductDescriptiveInformation(this.productUuid);
            }
        },

        // getProductDescriptiveInformation(productUuid){
        // 	getProductDescriptiveInformation(productUuid).then(res=>{
        // 			if(res.code==0){
        // 				this.productForm.productDesInfopOtherSpec = res.data.productDesInfopOtherSpec;
        // 				this.productForm.productDesInffeatures = res.data.productDesInffeatures;
        // 				this.productForm.productDesInfoCultivation = res.data.productDesInfoCultivation;
        // 				this.productForm.productDesInfoCommonProblem = res.data.productDesInfoCommonProblem;
        // 				this.productForm.productDesInfoafterService = res.data.productDesInfoafterService;
        // 				this.productForm.productDesInfodiscountPolicy = res.data.productDesInfodiscountPolicy;
        // 				this.productForm.productDesInfoPdfLinkList = res.data.productDesInfoPdfLinkList;
        // 				this.productForm.productDesInfoDiseasePestControl = res.data.productDesInfoDiseasePestControl;
        // 				this.productForm.productDesInfoPostHarvestProcessing = res.data.productDesInfoPostHarvestProcessing;
        // 			}
        // 		})
        // },


	
        saveListProductDescriptiveInformation(){
            if(!this.productUuid){
                this.$Message.warning('产品模板不能为空,请选择产品模板');
                return;
            }
            let productList= this.$refs.productList.mainTable.tableData.map(item=>item.productUuid);
            if(productList.length==0){
                this.$Message.warning('要修改的条数不能为0！');
                return;
            }
            //let data=Object.assign({},productList);
            //	this.saveLoading=true;
            // saveProductListDescriptiveInformation(data).then(res=>{
            // 	this.saveLoading=false;
            // 	if(res.code==0){			
            // 		this.$Message.info('保存成功');
            // 	}
            // 	else{
            // 		this.$Message.info(res.message);
            // 	}
            // });
            this.$refs.productPopupEdit.sumbit(productList);
        }
    },
	
    computed:{
        hasTemplateProduct(){
            return this.productUuid?true:false;
        }
    }
};
</script>

<style lang="less">
 .quillRow{
	margin:30px 0px 50px 0px;
 }
</style>
